<div class="ring-container position-{{position}}" *ngIf="showDot">
  <div class="ringring"></div>
  <div class="circle"></div>
</div>
